import React, { useEffect, useState } from 'react';
import { SocietyDataForm } from '../../../../app/models/Society';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import useRut from '../../../../hooks/useRut';

interface GeneralSocietyProps {
    societyForm: SocietyDataForm;
    setSocietyForm: (society: SocietyDataForm) => void;
    errorFields?: any;
    setErrorFields?: (errors: any) => void;
}

const SocietyForm = ({
    societyForm,
    setSocietyForm,
    errorFields,
    setErrorFields
}: GeneralSocietyProps) => {

    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();
    const { formatRut } = useRut();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const [image, setImage] = useState(
        societyForm.logo
            ? societyForm.logo
            : 'https://static.vecteezy.com/system/resources/previews/009/292/244/original/default-avatar-icon-of-social-media-user-vector.jpg'
    );

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value, type } = event.target;
        if (type === 'checkbox') {
            event.target = event.target as HTMLInputElement;
            setSocietyForm({ ...societyForm, [name]: event.target.checked });
        } else {
            if (name == 'rut') {
                setSocietyForm({ ...societyForm, [name]: formatRut(value) });
            } else {
                setSocietyForm({ ...societyForm, [name]: value });
            }
        }
    };

    const dataOnChangeImages = (e: any) => {
        setImage(URL.createObjectURL(e.target.files[0]));
        setSocietyForm({
            ...societyForm,
            [e.target.name]: e.target.files[0]
        });
    };

    const changeMultipleSelectTwo = (name: string, optionSelect: any) => {
        
        let obj = {};

        if (name === 'clients'){
            obj = { clients: optionSelect };
        }
        else if (name === 'societyForms'){
            obj = { societyForms: optionSelect };
        }
        

        setSocietyForm({
            ...societyForm,
            ...obj
        });
       
    };

    

    return (
        <>
            <div className="col-md-12 text-center d-flex">
                            <div className="mx-auto mb-3">
                                <label htmlFor="logo">
                                    <img
                                        src={
                                            typeof image === 'string' && image !== ''
                                                ? image
                                                : window.URL.createObjectURL(image as Blob)
                                        }
                                        className="rounded-circle pointer bg-white"
                                        style={{
                                            width: '150px',
                                            height: '150px',
                                            objectFit: 'cover'
                                        }}
                                    />
                                </label>
                            </div>
                       
                        </div>
                        <div className="mb-2 row needs-validation">
                            <label className="col-form-label">Origen</label>
                            <div className="col-md-12">
                                <input
                                    name="is_national"
                                    id="is_national"
                                    type="text"
                                    className={`form-control ${fieldHasError('is_national')}`}
                                    value={societyForm.is_national?"Nacional": "Extranjero"}
                                    readOnly={true}
                                />
                            </div>
                    </div>

                    {societyForm.is_national && 
                        <div className="mb-2 row">
                            <label className="col-form-label">Rut</label>
                            <div className="col-md-12">
                                <input
                                    name="rut"
                                    id="rut"
                                    type="text"
                                    className="form-control"
                                    value={societyForm.rut || ''}
                                    onChange={handleChange}
                                    onFocus={() => onFocusRemove('rut')}
                                    placeholder="Ingrese el RUT del proveedor"
                                    readOnly={true}
                                />
                                <div className="invalid-feedback" style={{ display: 'flex' }}>
                                    {fieldErrorMessage('rut')}
                                </div>
                            </div>
                        </div>
                    }
                       
                    <div className="mb-2 row needs-validation">
                        <label className="col-form-label">Razón Social</label>
                        <div className="col-md-12">
                            <input
                                name="name"
                                id="name"
                                type="text"
                                className={`form-control ${fieldHasError('name')}`}
                                value={societyForm.name}
                                onChange={handleChange}
                                onFocus={() => onFocusRemove('name')}
                                placeholder="Ingrese razón social de sociedad"
                                readOnly={true}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('name')}
                            </div>
                        </div>
                    </div>
                    <div className="mb-2 row">
                    <div className="col-md-12">
                        <label className="col-form-label">Nombre de Fantasía</label>
                        <input
                            name="fantasy_name"
                            id="fantasy_name"
                            type="text"
                            className="form-control"
                            value={societyForm.fantasy_name}
                            onChange={handleChange}
                            onFocus={() => onFocusRemove('fantasy_name')}
                            readOnly={true}
                        />
                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                            {fieldErrorMessage('fantasy_name')}
                        </div>
                    </div>               
                    </div>

                    

            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Email</label>
                    <input
                        name="email"
                        id="email"
                        type="text"
                        className="form-control"
                        value={societyForm.email}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('email')}
                        placeholder="Ingrese email"
                        readOnly={true}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('email')}
                    </div>
                </div>               
            </div>
            <div className='mb-2 row"'>
                <div className="col-md-12">
                    <label className="col-form-label">Dirección</label>
                    <input
                        name="address"
                        id="address"
                        type="text"
                        className="form-control"
                        value={societyForm.address}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('address')}
                        placeholder="Ingrese domicilio"
                        readOnly={true}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('address')}
                    </div>
                </div>               
            </div>
            <div className='mb-2 row'>
                <div className="col-md-12">
                    <label className=" col-form-label">Teléfono</label>
                    <div className="row">
                        <div className="col-auto">
                            <select
                                className="form-control form-control-custom pl-2"
                                id="phone_code"
                                name="phone_code"
                                onChange={handleChange}
                                value={societyForm.phone_code}
                                onFocus={() => onFocusRemove('phone_code')}
                                disabled={true}
                            >
                                <option value="">--</option>
                                <option value="+56">+56</option>
                            </select>
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('phone_code')}
                            </div>
                        </div>

                        <div className="col">
                            <input
                                name="phone"
                                id="phone"
                                type="number"
                                className="form-control"
                                value={societyForm.phone}
                                onChange={handleChange}
                                onFocus={() => onFocusRemove('phone')}
                                placeholder="Teléfono"
                                readOnly={true}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('phone')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        </>
    );
};

export default SocietyForm;
